// Global Instructions Rule Applied!
import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Avatar, Button, Card } from 'antd'
import { performLogout } from '../../../auth/authService'
import { avatarInitials } from '../lib/routes.ts'
import { text } from '../lib/format.ts'

/**
 * Account tab: who's signed in, a note that the phone is a read-only companion, and
 * sign out. Reuses the shared `performLogout` (Supabase sign-out + auth-slice reset +
 * redirect to /login).
 */
export function AccountScreen(): React.JSX.Element {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const user = useSelector((state: any) => state.auth?.user)
  const meta = (user?.user_metadata as Record<string, any>) || {}
  const displayName = meta.full_name || meta.name || user?.email || 'Signed in'
  const email = user?.email || meta.email

  const handleSignOut = () => {
    performLogout({ dispatch, navigate })
  }

  return (
    <div style={{ padding: 16 }}>
      <Card size="small" style={{ marginBottom: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <Avatar size={48} src={meta.avatar_url || undefined} style={{ backgroundColor: '#1890ff', color: '#fff' }}>
            {avatarInitials(displayName)}
          </Avatar>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontWeight: 600, fontSize: 16, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {text(displayName)}
            </div>
            <div
              style={{
                color: 'rgba(0,0,0,0.45)',
                fontSize: 13,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            >
              {text(email)}
            </div>
          </div>
        </div>
      </Card>

      <Card size="small" style={{ marginBottom: 12 }}>
        <div style={{ color: 'rgba(0,0,0,0.65)', fontSize: 13, lineHeight: 1.5 }}>
          This is the Reservoir mobile companion — a read-only view for quick lookups on the go. Creating and editing
          records, lists, and reports live in the full app on desktop.
        </div>
      </Card>

      <Button danger block onClick={handleSignOut}>
        Sign out
      </Button>
    </div>
  )
}

export default AccountScreen
